import Vue from 'vue';


Vue.component('cta', {
    template: `<div class="vc-cta" v-bind:class="[cssclass, (isdisabled) ? 'disabled': '']" v-cloak v-on:click='callAction' style="text-align: center;">
                  <span v-if="!submitInProgress">{{label}}</span>
                  <span v-if="submitInProgress"> <equalizer></equalizer> </span>
               </div>`,
    props: {
        label: {
            type: String,
            required: true,
            default: 'Sign In'
        },
        url: {
            type: String,
            default: '/account/register'
        },
        type: {
            type: String,
            default: 'REDIRECT',
            validator: function (value) {
                return ['GET', 'POST', 'REDIRECT'].indexOf(value) !== -1
            }
        },
        parameters: {
            type: Object,
            default: null
        },
        callback: {
            type: Function
        },
        cssclass: {
            type: String,
            default: '',
            required: false
        },
        isdisabled: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data: function () {
        return {
            submitInProgress: false
        };
    },
    methods: {
        callAction: function () {
            if (!this.isdisabled) {
                this.submitInProgress = true;
                this.isdisabled = true;
                pixel.initiateCheckout('cta_button');

                if (this.type == 'REDIRECT') {
                    window.location = this.url;
                }

                else {
                    var options = {
                        cache: 'no-cache',
                        credentials: 'include',
                        headers: { 'content-type': 'application/json' },
                        method: this.type,
                        mode: 'cors',
                        redirect: 'manual', // manual, follow, error
                        referrer: 'no-referrer' // client, no-referrer
                    };

                    if (this.type != "GET") {
                        options.body = JSON.stringify(this.parameters);
                    }

                    fetch(this.url, options)
                        .then(response => response.json())
                        .then(data => {
                            if (!(data == null && typeof (this.callback) === typeof (Function))) {
                                this.callback(data);
                                this.submitInProgress = false;
                                this.isdisabled = false;
                            }
                        })
                        .catch(error => {
                            console.log(error);
                            this.submitInProgress = false;
                            this.isdisabled = false;
                        });
                }
            }
        }
    }
});


// WEBPACK FOOTER //
// ./Content/js/app/components/vc-cta.js